/**
 * Box-level write API — currently just the STACKED toggle.
 *
 * Same base URL + error shape as ticketsApi (they hit the same
 * ticket_api_server process). Kept in a separate file because the
 * boxes routes use a different URL prefix (`/api/boxes/...`) and
 * the function names are clearer here.
 */
import { ApiError, apiFetch } from "./apiClient";
import { TicketApiError } from "./ticketsApi";

export interface SetStackedResponse {
  scu_name: string;
  is_stacked: boolean;
  override_id: number;
  outage_closed_id: number | null;
  jcox_tickets_resolved: number[];
  source_overlays_written: number[];
}

export async function setBoxStacked(
  scuName: string,
  isStacked: boolean,
  by: string,
  notes?: string,
): Promise<SetStackedResponse> {
  // Now served by the AUTHENTICATED app API (folded in from the retired :8089
  // service) -- must carry the session token via the `access-token` header.
  const token = localStorage.getItem("mttr_token");
  try {
    return await apiFetch<SetStackedResponse>(
      `/api/boxes/${encodeURIComponent(scuName)}/stacked`,
      token,
      {
        method: "POST",
        body: JSON.stringify({ is_stacked: isStacked, by, notes: notes ?? null }),
      },
    );
  } catch (e) {
    if (e instanceof ApiError) {
      // Preserve the historical "<status>: <detail>" message shape.
      const msg = e.status != null ? `${e.status}: ${e.message}` : e.message;
      throw new TicketApiError(msg, e.status);
    }
    throw e;
  }
}
